import React from 'react'

const HoneySubNav = ({showPage, goToPage}) => {
    return (
        <div id="sub-nav-outer-wrapper">
            <div className="contain">
                <div id="honey-sub-nav-wrap">
                    <div className="sub-nav-item">
                        <button id="btn-hive-location" onClick={() => goToPage(1)} className={showPage===1 ? 'active' : ''} >
                            Hive
                        </button>
                    </div>
                    <div className="sub-nav-item">
                        <button id="btn-harvest-location" onClick={() => goToPage(2)} className={showPage===2 ? 'active' : ''}>
                            Harvest
                        </button>
                    </div>
                    <div className="sub-nav-item">
                        <button id="btn-packing-location" onClick={() => goToPage(3)} className={showPage===3 ? 'active' : ''} >
                            Packing
                        </button>
                    </div>
                    <div className="sub-nav-item">
                    <button id="btn-profile-location"  onClick={() => goToPage(4)} className={showPage===4 ? 'active' : ''}>
                        Profile
                    </button>
                </div>
                </div>
            </div>
        </div>
    )
}

export default HoneySubNav
